import gsap from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import { Maths } from '../_app/cuchillo/utils/Maths';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import HomeScene from '../3D/HomeScene';
import HelmetHolder from './HelmetHolder';

// Sub-rangs del progrés del widget (this.progress = progressItem, 0→1 mentre el widget travessa
// el viewport). Cada sub-rang mapeja una part de l'animació de show (reversible amb l'scroll):
//   - title:  reveal del title-torcido
//   - helmet: moviment 3D dels helmets. DINS d'aquest (a HelmetHolder) hi ha el sub-rang del button.
const RANGES = {
    title: [0.12, 0.28],
    helmet: [0, .6],
    helmetMobile: [0, .5],
};

// Stagger entre helmets: l'helmet d'índex `i` desplaça el seu rang `i * HELMET_STAGGER` cap
// endavant (mateixa durada, però comença/acaba una mica més tard). 0 = sense stagger (tots alhora).
const HELMET_STAGGER = 0.06;

class ScrollItem__WidgetHome extends ScrollItem__BlockDefault {
    static _instance = null;

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        ScrollItem__WidgetHome._instance = this;

        // Un HelmetHolder per button/helmet (mateix ordre DOM que HomeScene._tapones).
        // Els _buttons ja els ha mesurat i preparat (width:0) ScrollItem__BlockDefault.
        this._helmets = this._buttons.map((b, i) => new HelmetHolder(b, i));

        // Estat inicial amagat (title width 0).
        this._drawTitle(0);

        // Show/hide MAPEJAT a l'scroll (bidireccional): tot es deriva del progrés del widget.
        this.onShow = () => { };
        this.onHide = () => { };
        this.onMove = () => {
            // Durant el click d'un tapon manen les animacions del click (hideTitle/hideButton).
            if (HomeScene._taponSelected) return;

            const R = isMobile ? RANGES.helmetMobile : RANGES.helmet;
            const p = this.progressItem; // 0→1 mentre el widget travessa el viewport (getter, sempre fresc)

            // 1) Rang inicial: title-torcido
            this._drawTitle(Maths.clamp(Maths.normalize(RANGES.title[1], RANGES.title[0], p), 0, 1));

            // 2) Rang de moviment dels helmets (+ sub-rang del button, dins HelmetHolder).
            //    Cada helmet desplaça el seu rang `i * HELMET_STAGGER` (stagger).
            this._helmets.forEach((h, i) => {
                const start = R[0] + i * HELMET_STAGGER;
                const end = R[1] + i * HELMET_STAGGER;
                const helmetP = Maths.clamp(Maths.normalize(end, start, p), 0, 1);
                h.loop(helmetP);
            });

            HomeScene.updateLightTargets(); // les llums segueixen els helmets mentre es mouen
        };

        // a11y: els <a>.button-torcido naveguen sol·lets sense JS (href).
        // Amb JS, cancel·lem la navegació nativa i disparem el mateix flux que el
        // tapon 3D (selecció de tipus + animació general → navega al final).
        this._onButtonClick = (e) => {
            const btn = e.currentTarget;
            e.preventDefault();
            const bi = this._buttons.findIndex(b => b.btn === btn);
            if (bi < 0) return;
            const src = btn.getAttribute('href') || btn.dataset.url || '';
            HomeScene.onTaponClick(bi, src, btn.dataset.type);
        };
        this._buttons.forEach(({ btn }) => {
            btn.addEventListener(Basics.clickEvent, this._onButtonClick);
        });
    }

    dispose() {
        if (this._buttons) {
            this._buttons.forEach(({ btn }) => {
                btn.removeEventListener(Basics.clickEvent, this._onButtonClick);
            });
        }
        super.dispose();
    }

    // Reveal del title-torcido mapejat al progrés (width màscara 0→final + opacity ràpida).
    _drawTitle(tp) {
        this._titles.forEach(({ span, p, finalW }) => {
            span.style.width = `${tp * finalW}px`;
            if (p) p.style.opacity = Maths.clamp(tp * 4, 0, 1);
        });
    }

    // Amaga el/els title-torcido (revers del show, cridat des del click d'un tapon a HomeScene).
    static hideTitle() {
        const inst = this._instance;
        if (!inst) return;
        inst._titles.forEach(({ span, p }) => {
            gsap.killTweensOf(span);
            gsap.to(span, { width: 0, duration: 0.6, ease: 'power3.in' });
            if (p) { gsap.killTweensOf(p); gsap.to(p, { opacity: 0, duration: 0.3 }); }
        });
    }

    // Amaga un button-torcido concret (revers del show, cridat des del click d'un tapon a HomeScene).
    static hideButton(index) {
        const inst = this._instance;
        if (!inst) return;
        const b = inst._buttons[index];
        if (!b) return;
        gsap.killTweensOf(b.btn);
        gsap.to(b.btn, { width: 0, duration: 0.6, ease: 'power3.in' });
        if (b.span) { gsap.killTweensOf(b.span); gsap.to(b.span, { opacity: 0, duration: 0.3 }); }
    }
}

Scroll._registerClass('WidgetHome', ScrollItem__WidgetHome);

export default ScrollItem__WidgetHome;
